import React, { useEffect, useRef, useMemo } from 'react';

const PdfSourceTextBlock = ({ block = [] }) => {
    const containerRef = useRef(null);

    // Memoize the block segments to prevent unnecessary re-renders
    const segments = useMemo(() => {
        return Array.isArray(block) ? block : [];
    }, [block]);

    // Effect to update the content display when blocks change
    useEffect(() => {
        if (!containerRef.current) return;

        // Create a document fragment for better performance
        const fragment = document.createDocumentFragment();

        segments.forEach(segment => {
            if (!segment?.text) return; // Skip invalid segments

            const span = document.createElement('span');
            span.textContent = segment.text;

            // Set data attributes safely
            if (segment.id) span.dataset.id = segment.id;
            if (segment.paraId) span.dataset.paraId = segment.paraId;
            if (segment.textId) span.dataset.textId = segment.textId;
            if (segment.sentId) span.dataset.sentId = segment.sentId;

            // Apply consistent styling
            Object.assign(span.style, {
                margin: '0 2px',
                borderRadius: '4px',
                display: 'inline',
             
            });

            // Apply custom class if provided
            if (segment.style) {
                span.className = segment.style;
            }

            fragment.appendChild(span);
        });

        // Clear and update in one operation
        containerRef.current.innerHTML = '';
        containerRef.current.appendChild(fragment);

    }, [segments]);

    return (
        <div
            ref={containerRef}
            className="p-1"
            style={{
                width: '100%',
                minHeight: '20px',
                overflow: 'hidden',
                textAlign: 'start',
                fontSize: '14px',
                lineHeight: '1.5',
                borderRadius: '5px',
            }}
        />
    );
};

export default React.memo(PdfSourceTextBlock);